import { getChangePasswordUrl } from "@husky-hrc/Utilities/HuskyExternalAuth";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ExternalProviderLinkModel } from "@insite/client-framework/Services/IdentityService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadExternalProviders from "@insite/client-framework/Store/Pages/SignIn/Handlers/LoadExternalProviders";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    externalProviders: state.pages.signIn.externalProviders,
});

const mapDispatchToProps = {
    loadExternalProviders,
};

interface OwnProps {
    extendedStyles: ButtonPresentationProps;
    buttonText: string;
    variant: "primary" | "secondary" | "tertiary";
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const externalAuthButtonStyles: ButtonPresentationProps = {};

const ChangePasswordButton = ({
    externalProviders,
    loadExternalProviders,
    buttonText,
    extendedStyles,
    variant,
}: Props) => {
    const [styles] = React.useState(() => mergeToNew(externalAuthButtonStyles, extendedStyles));

    useEffect(() => {
        if (!externalProviders) {
            loadExternalProviders();
        }
    }, []);

    const providerButtonClickHandler = (externalProviders: ExternalProviderLinkModel[] | undefined) => {
        if (externalProviders) {
            const url = getChangePasswordUrl(externalProviders);
            window.location.href = url;
        }
    };

    if (!externalProviders || externalProviders.length === 0) {
        return null;
    }

    return (
        <>
            <Button {...styles} variant={variant} onClick={() => providerButtonClickHandler(externalProviders)}>
                {buttonText}
            </Button>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordButton);
